module.exports = __webpack_public_path__ + "img/Support-3.6ffacb19.png";